<glxy-alert *ngIf="!openAsReadOnly" type="tip" class="page-description">
  {{ 'EMAIL_LIBRARY.PAGE_DESCRIPTION' | translate }}
</glxy-alert>

<div class="search">
  <glxy-form-field class="search-bar" [suffixIcon]="'search'" [showLabel]="false" [bottomSpacing]="'none'">
    <input matInput [formControl]="searchField" [placeholder]="'EMAIL_LIBRARY.SEARCH_PLACEHOLDER' | translate" />
  </glxy-form-field>
  <span class="counter">
    <ng-container *ngIf="templates.totalResults$ | async as totalResults">
      <ng-container *ngIf="totalResults === 1">
        {{ 'EMAIL_LIBRARY.TOTAL_RESULTS_SINGULAR' | translate: { totalResults: 1 } }}
      </ng-container>
      <ng-container *ngIf="totalResults !== 1">
        {{ 'EMAIL_LIBRARY.TOTAL_RESULTS_PLURAL' | translate: { totalResults: totalResults } }}
      </ng-container>
    </ng-container>
  </span>
</div>

<mat-accordion [multi]="true" *ngIf="!openAsReadOnly; else myTemplates">
  <mat-expansion-panel class="featured-list" [expanded]="true">
    <mat-expansion-panel-header>{{ 'EMAIL_LIBRARY.FEATURED_TEMPLATES' | translate }}</mat-expansion-panel-header>
    <email-cards
      [templates]="systemTemplates$ | async"
      [ownerType]="ownerType"
      [ownerId]="ownerId"
      [appNamespace]="AppNamespace"
      [defaultAction]="DefaultCardAction.DUPLICATE"
      (readOnlyEmailClicked)="handleReadOnlyEmailClicked($event)"
    ></email-cards>
  </mat-expansion-panel>
  <mat-expansion-panel class="featured-list hide-pointer" [expanded]="true" [hideToggle]="true">
    <mat-expansion-panel-header>{{ 'EMAIL_LIBRARY.MY_TEMPLATES' | translate }}</mat-expansion-panel-header>
    <email-cards
      *ngIf="(templates$ | async)?.length !== 0"
      [templates]="templates$ | async"
      [ownerType]="ownerType"
      [ownerId]="ownerId"
      [appNamespace]="AppNamespace"
      [defaultAction]="myTemplatesDefaultAction"
      [openAsReadOnly]="openAsReadOnly"
      (readOnlyEmailClicked)="handleReadOnlyEmailClicked($event)"
    ></email-cards>

    <ng-container *ngIf="(templates$ | async)?.length === 0">
      <ng-container *ngIf="showingAllTemplates$$ | async; else noResults">
        <glxy-empty-state class="empty-library">
          <glxy-empty-state-hero>
            <mat-icon>mail</mat-icon>
          </glxy-empty-state-hero>
          <glxy-empty-state-title>
            {{ 'EMAIL_LIBRARY.EMPTY_LIBRARY_PAGE.TITLE' | translate }}
          </glxy-empty-state-title>
          <div>{{ 'EMAIL_LIBRARY.EMPTY_LIBRARY_PAGE.DESCRIPTION' | translate }}</div>
          <p>{{ 'EMAIL_LIBRARY.EMPTY_LIBRARY_PAGE.SUGGESTION' | translate }}</p>
          <ng-container *ngIf="!openAsReadOnly">
            <glxy-empty-state-actions>
              <a [routerLink]="['./' + PAGE_ROUTES.ROOT.TEMPLATE_SUBROUTES.NEW]">
                <button mat-raised-button color="primary">
                  {{ 'EMAIL_LIBRARY.CREATE_EMAIL_BUTTON_TEXT' | translate }}
                </button>
              </a>
            </glxy-empty-state-actions>
          </ng-container>
        </glxy-empty-state>
      </ng-container>

      <ng-template #noResults>
        <glxy-empty-state>
          <glxy-empty-state-hero>
            <mat-icon>mail</mat-icon>
          </glxy-empty-state-hero>
          <div>{{ 'EMAIL_LIBRARY.NO_RESULTS' | translate }}</div>
        </glxy-empty-state>
      </ng-template>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #myTemplates>
  <mat-expansion-panel class="featured-list hide-pointer" [expanded]="(templates$ | async)?.length > 0 || false">
    <mat-expansion-panel-header>{{ 'EMAIL_LIBRARY.MY_TEMPLATES' | translate }}</mat-expansion-panel-header>
    <email-cards
      [templates]="templates$ | async"
      [ownerType]="ownerType"
      [ownerId]="ownerId"
      [userId]="userId"
      [appNamespace]="AppNamespace"
      [defaultAction]="myTemplatesDefaultAction"
      [openAsReadOnly]="openAsReadOnly"
      (readOnlyEmailClicked)="handleReadOnlyEmailClicked($event)"
    ></email-cards>
  </mat-expansion-panel>
  <mat-expansion-panel class="featured-list" [expanded]="true">
    <mat-expansion-panel-header>{{ 'EMAIL_LIBRARY.FEATURED_TEMPLATES' | translate }}</mat-expansion-panel-header>
    <email-cards
      [templates]="systemTemplates$ | async"
      [ownerType]="ownerType"
      [ownerId]="ownerId"
      [appNamespace]="AppNamespace"
      [defaultAction]="myTemplatesDefaultAction"
      [openAsReadOnly]="openAsReadOnly"
      (readOnlyEmailClicked)="handleReadOnlyEmailClicked($event)"
    ></email-cards>
  </mat-expansion-panel>
</ng-template>

<ng-container *ngIf="templates.loading$ | async">
  <glxy-loading-spinner [fullWidth]="true" size="large"></glxy-loading-spinner>
</ng-container>

<ng-container *ngIf="(templates.items$ | async)?.length > 0 && (templates.hasMore$ | async) === false">
  <glxy-alert type="tip">
    {{ 'EMAIL_LIBRARY.BROWSER.END_OF_RESULTS' | translate }}
  </glxy-alert>
</ng-container>

<ng-container *ngIf="(templates.loading$ | async) === false">
  <glxy-infinite-scroll-trigger (isVisible)="loadMore()"></glxy-infinite-scroll-trigger>
</ng-container>
